import React from 'react';
import { AdminContextMenu } from './AdminContextMenu';
import type { TileViewModel, TileableModel } from '../view-models/tile';
import { TileKPISummary } from './TileKPISummary';

interface AdminTileProps {
    children: React.ReactNode;
    tile: TileViewModel<TileableModel>;
    actions?: {
        onEdit?: () => void;
        onRepositionImage?: () => void;
        onDelete?: () => void;
        onTogglePin?: () => void;
        onToggleFeature?: () => void;
        onToggleFeaturedBrandPin?: () => void;
        onRemoveFromLibrary?: () => void;
    };
}

export const AdminTile: React.FC<AdminTileProps> = ({
    children,
    tile,
    actions,
}) => {
    const { adminStatusInfo } = tile;

    return (
        <AdminContextMenu
            {...actions}
            statusInfo={adminStatusInfo ?? undefined}
        >
            {children}
            {adminStatusInfo?.kpi && (
                <TileKPISummary kpi={adminStatusInfo.kpi} />
            )}
        </AdminContextMenu>
    );
};
